import axiosClient from "./axios";

/**
 * Kullanıcının burcuna ait güncel aylık yorumu getirir
 * @returns {Promise} Aylık horoskop verisi
 */
export const getHoroscopeMonthly = async () => {
  try {
    const response = await axiosClient.get("/module/horoscope/my-monthly");
    return response.data.data; // API response.data içinde data var
  } catch (error) {
    console.error("Aylık horoskop verisi alınırken hata:", error);
    throw error;
  }
};

/**
 * Kullanıcının burcuna ait güncel haftalık yorumu getirir
 * @returns {Promise} Haftalık horoskop verisi
 */
export const getHoroscopeWeekly = async () => {
  try {
    const response = await axiosClient.get("/module/horoscope/my-weekly");
    return response.data.data; // API response.data içinde data var
  } catch (error) {
    console.error("Haftalık horoskop verisi alınırken hata:", error);
    throw error;
  }
};

